import React from 'react';
import PropTypes from 'prop-types';

import { CSSTransition, TransitionGroup } from 'react-transition-group';
import FA from 'react-fontawesome';

import Modal from '../Components/Modal';
import Promt from '../Components/Promt';

const ModalEncender = ({
  visible,
  close,
  unidades,
  openPromt,
  promtVisible,
  closePromt,
  encenderAuto,
}) => (
  <TransitionGroup>
    {visible && (
      <CSSTransition
        in={visible}
        key="modal02"
        classNames="modal"
        timeout={{ enter: 500, exit: 300 }}
      >
        <Modal className="modal" close={close}>
          <h3>
            Selecciona la unidad a
            {' '}
            <span className="darkcyan">encender</span>
          </h3>
          <TransitionGroup>
            {unidades.map(unidad => (
              <CSSTransition key={unidad.idUnidad} classNames="modal-item" timeout={800}>
                <div
                  key={unidad.idUnidad}
                  className="modal-item"
                  onClick={() => openPromt(unidad.chip)}
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex={0}
                >
                  <FA name="car" size="2x" className="darkcyan" />
                  <span>
                    Unidad:
                    {' '}
                    {unidad.unidad}
                  </span>
                </div>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </Modal>
      </CSSTransition>
    )}
    {promtVisible && (
      <CSSTransition key="promt-encender01" classNames="promt" timeout={300}>
        <Promt className="promt" close={closePromt} confirm={encenderAuto}>
          <h3>
            ¿Desea
            {' '}
            <span className="darkcyan">encender</span>
            {' '}
            la unidad?
          </h3>
        </Promt>
      </CSSTransition>
    )}
  </TransitionGroup>
);

ModalEncender.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  unidades: PropTypes.arrayOf(
    PropTypes.shape({
      idUnidad: PropTypes.number,
      chip: PropTypes.string,
      unidad: PropTypes.string,
    }),
  ).isRequired,
  openPromt: PropTypes.func.isRequired,
  promtVisible: PropTypes.bool.isRequired,
  closePromt: PropTypes.func.isRequired,
  encenderAuto: PropTypes.func.isRequired,
};

export default ModalEncender;
